import { render, staticRenderFns } from "./ImportResultModal.vue?vue&type=template&id=2b39d040"
import script from "./ImportResultModal.vue?vue&type=script&lang=js"
export * from "./ImportResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports